import Styles from './Drawer.module.scss'
import { ForwardedRef, forwardRef, PropsWithChildren } from 'react'
import { WithClassName, WithFullHeight, WithPadding } from 'components/Drawer/Types'
import cx from 'classnames'

type Props = PropsWithChildren<WithFullHeight & WithPadding & WithClassName>

export const Container = forwardRef(
  ({ children, fullHeight = false, padding, className }: Props, ref: ForwardedRef<HTMLDivElement>) => (
    <div ref={ref} className={cx(Styles.container, className, { [Styles.fullHeight]: fullHeight })} style={{ padding }}>
      {children}
    </div>
  ),
)
